const showError = (errorClass, messageKey) => {
	const errorBanner = document.querySelector(errorClass);
	errorBanner.classList.remove('hidden');
	let translatedMessage = errorBanner.dataset[messageKey ?? 'somethingWrong'];
	if(!translatedMessage){
		translatedMessage = errorBanner.dataset.somethingWrong;
	}
	errorBanner.querySelector('.id-error').textContent =  translatedMessage;
}

const hiddenError = (errorClass) => {
	const errorBanner = document.querySelector(errorClass);
	errorBanner.classList.add('hidden');
}
